import { flushByTag } from '@tuic/cache';

import type { SPACE_NAME } from './clients';

export const createSpaceCacheTag = (space: SPACE_NAME) => {
  return `s:${space}`;
};

export const createContentTypeCacheTag = (contentType: string) => {
  return `ct:${contentType}`;
};

export const flushByContentType = async (contentType: string | string[]) => {
  if (Array.isArray(contentType)) {
    await Promise.all(contentType.map(type => flushByContentType(type)));

    return;
  }

  const tag = createContentTypeCacheTag(contentType);

  await flushByTag(tag);
};

export const flushBySpace = async (space: SPACE_NAME | SPACE_NAME[]) => {
  if (Array.isArray(space)) {
    await Promise.all(space.map(spaceName => flushBySpace(spaceName)));

    return;
  }

  const tag = createSpaceCacheTag(space);

  await flushByTag(tag);
};
